import React from 'react';

import { cssMap } from '@atlaskit/css';
import HashtagIcon from '@atlaskit/icon/core/hashtag';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.medium'),
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
});

export const LoomTagIcon = (): React.JSX.Element => (
	<Box testId="loom-tag-icon" xcss={styles.container}>
		<HashtagIcon label="" color={token('color.icon.accent.purple')} size="small" spacing="none" />
	</Box>
);
